export default {
  listCatalog: [],
  listCatalogFilter: {
    data: [],
    maxPage: 1,
    currentPage: 1
  },
  loading: true,
  loadingCategories: false
}
